import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.75 11.75V6.5H11.25V11.75H6V13.25H11.25V18.5H12.75V13.25H18V11.75H12.75Z", fill: "currentColor" }));
export default SvgAdd;
